import { CollectionController } from 'controller/collection'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { IEventCollectionDataActiveTypeticketcollections, IEventCollectionMetadata } from 'meta/pages/v4/eventCollection'
import { RootState } from 'store/types'

type Params = {
  collectionId: string
  page: number
}

type Returned = {
  data: IEventCollectionDataActiveTypeticketcollections,
  metadata: IEventCollectionMetadata,
  collectionId: string
}

export const getActiveTypeticketcollections = createAsyncThunk<Returned, Params, { state: RootState }>(
  'collection/getActiveTypeticketcollections',
  async (params) => {
    const { collectionId, page } = params

    const { data, metadata } = await CollectionController.getActiveTypeticketcollections({ collectionId, page })

    return { data, metadata, collectionId }
  }
)
